<template>
  <div>
    <Title :pages="[
      { icon: 'users', path: '/legajos', page: 'LEGAJOS' },
      { icon: 'circle', page: getName() },
    ]"></Title>

    <v-container>
      <v-tabs
      v-model="tab"
      background-color="#fff"
      slider-color="transparent"
      class="custom-tabs"
    >
      <v-tab
        v-for="(item, index) in items"
        :key="index"
        class="custom-tab"
        :class="{ 'active-tab': tab === index }"
      >
        {{ item }}
      </v-tab>
    </v-tabs>
      <v-tabs-items v-model="tab" background-color="transparent">
        <v-tab-item v-for="(item, index) in items" :key="item">
    
          <LegajoInfo v-if="index === 0" :legajo="legajo" :loading_legajo="loading_legajo" :service="legajoService"/>
          <LegajoDocuments v-else-if="index === 1" :folders="folders" :loading_folders="loading_folders" :service="legajoService" @loadFolders="loadFolders($route.params.id)" :legajo_id="legajo_id"/>
        </v-tab-item>
      </v-tabs-items>


    </v-container>
  </div>
</template>

<script>
import Title from "@/components/Title.vue";
import LegajoInfo from "./LegajoInfo.vue";
import LegajoDocuments from "./LegajoDocuments.vue";
import { legajoService } from "../../libs/ws/legajoService";
import { folderService } from "../../libs/ws/folderService";

export default {
  components: { Title, LegajoInfo, LegajoDocuments },
  name: "LegajoForm",
  props: {

  },
  data() {
    return {
      isNew: true,
      formValid: false,
      legajoService: legajoService,
      folderService: folderService,
      legajo: {
        id: 0,
        name:"",
        surname:"",
        document_type:"",
        document: "", 
        cuil: "",
        photo_file: null,
        external_reference: "",
        birthdate: "",
        gender: "",
        nationality: "",
        civil_status: "",
        disability: "",
        level_study: "",
        hire_date: null,
        finish_date: null,
        address: "",
        postal_code:"",
        locality:"",
        phone: "",
        email: "",
        observations: "",
        province: null,
        workstation: null,
        worksector: null,
        sucursal: null,
        
      },
      folders: [],
      page_title: "Legajo",
      tab: 0,
      items: [
        'Legajo'
      ],
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      loading_legajo: false,
      loading_folders: false,
      legajo_id: null
    };
  },
  created() {
    this.isNew = this.$route.params.id == 'new';

    if (!this.isNew) {
      this.legajo_id = this.$route.params.id;
      this.items.push('Documentos');
      this.loadLegajo(this.legajo_id);
      this.loadFolders(this.legajo_id);
    }
  },
  methods: {
    getName() {
      return !this.isNew ? this.legajo.name : "Nuevo Legajo";
    },
    loadLegajo(id) {
      this.loading_legajo = true;

      legajoService
        .get(parseInt(id))
          .then((response) => {
            // El combo de provincia usa "province"; el backend la devuelve como "provincia"
            this.legajo = Object.assign({}, response.result, { province: response.result.provincia || null });
           
            console.log("legajo", this.legajo);
            console.log("response", response.result);
          })
          .catch((e) => {
            console.log("error service legajo get load.error");
            console.log(e);
          })
          .finally(() => {
            this.loading_legajo = false;
          });
    },
    loadFolders(legajo_id) {
      this.loading_folders = true;

      const params = {
        legajo: legajo_id,
      };

      folderService
        .getFoldersByLegajo(params)
          .then((response) => {
            this.folders = response.result;
            console.log("folders", this.folders);
          })
          .catch((e) => {
            console.log("error service folder get load.error");
            console.log(e);
          })
          .finally(() => {
            this.loading_folders = false;
          });

    },
    goBack() {
      this.$router.push("/legajos");
    },
  },
};
</script>
